import { API_URL } from '../../common/utils';
import { AuthData, saveAuthData, getRefreshToken } from './storage.service';

export const loginService = async (email: string, password: string): Promise<AuthData> => {
  try {
    const response = await fetch(`${API_URL}/auth/login`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ email, password }),
    });

    if (!response.ok) {
      throw new Error('Credenciales inválidas');
    }

    const authData: AuthData = await response.json();
    saveAuthData(authData);
    return authData;
  } catch (error) {
    console.error('Error en el login:', error);
    throw error;
  }
};

export const refreshTokenService = async (): Promise<AuthData | null> => {
  const refreshToken = getRefreshToken();
  
  if (!refreshToken) {
    return null;
  }

  try {
    const response = await fetch(`${API_URL}/auth/refresh`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ refreshToken }),
    });

    if (!response.ok) {
      throw new Error('Error al refrescar el token');
    }

    const authData: AuthData = await response.json();
    saveAuthData(authData);
    return authData;
  } catch (error) {
    console.error('Error al refrescar el token:', error);
    return null;
  }
}; 